import React, { useState } from "react";
import { Link } from "react-router-dom";
import MetaData from "../../components/layout/MetaData";
import emailjs from "emailjs-com";

export default function ContactUsScreen() {
  // State for managing form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    subject: "",
    message: "",
  });

  // Function to handle changes in form inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function to handle form submission
const handleSubmit = (e) => {
  e.preventDefault();

  // Sending email through EmailJS
  emailjs
    .send(
      "service_cbag33a", // EmailJS Service ID (已更新 2026-06-15)
      "template_zqhxdqr", // TODO: 请确认该模板 ID 在新账号中是否存在
      formData,
      "HxIhzpQAa5rMnG2Pz" // EmailJS Public Key (已更新 2026-06-15)
    )
    .then(
      (result) => {
        // console.log("Email sent: ", result.text);
        // Reset form or show success message
      },
      (error) => {
        // console.log("Email sending error: ", error.text);
        // Handle errors here
      }
    );
};

  return (
    <>
      <MetaData title="Contact Us" />
      <div className="container-fluid">
      <div className="contact-us-section">
        <div className="row">
          <div className="col-lg-8">
            <h2>Contact Us for More Information</h2>
            <p className="sub-title">
              Have some questions? Fill out the form to reach us.{" "}
              <em>Fields marked with * are mandatory.</em>
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  name="company"
                  id="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  name="message"
                  id="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <button type="submit" className="btn btn-primary mt-2">
                Submit
              </button>
            </form>
          </div>
          <div className="col-lg-4">
            <h2>Contact Details</h2>
            <p className="contact-details">
              Creatyea Technology (SZ) CO Limited, RM1903 - 1905, 19/F, Qiu Shi,
              West BLDG, Zhu Zi Lin, Fu Tian Estate, Shen Zhen, 518031 GD,
              China.
            </p>
            <Link to="mailto:hello@creatyea.com">hello@creatyea.com</Link>
            <Link to="tel:+8613538239881">+86-13538239881</Link>
            <h2>Follow Us On</h2>
            <Link to="https://www.facebook.com/creatyea">
              <img src="/img/facebook_logo_blue.png" alt="Facebook" />
            </Link>
            <Link to="https://www.instagram.com/creatyea">
              <img src="/img/instagram_logo_blue.png" alt="Instagram" />
            </Link>
          </div>
        </div>
        </div>
      </div>
    </>
  );
}
